import React from 'react';
import { Rocket, FileCheck, Sparkles, Shield, BarChart, Users } from 'lucide-react';

const EducationKPIs = () => {
  const kpis = [
    { icon: Rocket, text: 'Faster staff onboarding' },
    { icon: FileCheck, text: 'Reduced compliance and administrative workload' },
    { icon: Sparkles, text: 'Increased confidence in high-stakes conversations' },
    { icon: Shield, text: 'Improved safety preparedness' },
    { icon: BarChart, text: 'Higher consistency across schools' },
    { icon: Users, text: 'Stronger leadership readiness' }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-indigo-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Districts Using Traain See <span className="text-cyan-400">Measurable Gains</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {kpis.map((kpi, index) => {
            const Icon = kpi.icon;
            return (
              <div
                key={index}
                className="p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-indigo-900/20 border border-cyan-500/30 hover:border-cyan-400/60 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300"
              >
                <Icon className="w-10 h-10 text-cyan-400 mb-4" />
                <p className="text-lg text-gray-300">{kpi.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EducationKPIs;
